import { CustomFields } from '~/commons/interfaces/models/common/CustomField'

export function getCustomFields(entry: any): CustomFields {
  return entry?.translated?.customFields || entry?.customFields || {}
}
